<div class="dialog-content-wrapper">
    <!-- Header -->
    <mat-toolbar class="mat-accent m-0">
        <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
            <div class="header-title">
                @if (action == "NEW") {
                    <span class="title dialog-title">{{ "DEVICES.NewDevice" | translate }}</span>
                }
                @if (action == "EDIT") {
                    <span class="title dialog-title">{{ device.deviceName }}</span>
                }
                @if (isReadOnly) {
                    <span class="header-title__subtitle">{{ "DEVICES.EditLockedDescription" | translate }}</span>
                }
            </div>

            <div class="header-actions">
                @if (isReadOnly) {
                    <div class="header-lock-badge">
                        <mat-icon>lock</mat-icon>
                        <span>{{ "DEVICES.EditLockedBadge" | translate }}</span>
                    </div>
                }
                @if (action == "NEW") {
                    <button
                        mat-raised-button
                        class="btn-save"
                        (click)="save()"
                        [disabled]="deviceMetadataLoading || isReadOnly || (deviceMetadataLoaded && deviceForm?.invalid)"
                    >
                        {{ "PROJECTS.ADD" | translate }}
                    </button>
                }
                @if (action == "EDIT") {
                    <button
                        mat-raised-button
                        class="btn-save"
                        (click)="save()"
                        [disabled]="deviceMetadataLoading || isReadOnly || (deviceMetadataLoaded && deviceForm?.invalid)"
                    >
                        {{ "DEVICES.SAVE" | translate }}
                    </button>
                }
                <button mat-raised-button (click)="cancel()">
                    {{ "PROJECTS.CANCEL" | translate }}
                </button>
            </div>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="project-device-dialog-content" fusePerfectScrollbar>
        <div class="project-device-dialog-body">
            <form name="deviceForm" [formGroup]="deviceForm" class="device-form w-100-p" fxLayout="column" fxFlex>
                <!-- Device Info + Photo side by side -->
                <div class="device-info-row">
                    <div class="device-info-fields">
                        <div class="section">
                            <h2 class="section__title">
                                <mat-icon>business</mat-icon>
                                <div>{{ "DEVICES.DeviceInfo" | translate }}</div>
                            </h2>

                            <!-- Base Device -->
                            <mat-form-field appearance="outline">
                                <mat-select
                                    formControlName="baseDevice"
                                    placeholder="Base Device"
                                    required
                                    (selectionChange)="updatedBaseDevice()"
                                >
                                    @for (device of devices; track device) {
                                        <mat-option [value]="device.id"> {{ device.name }} -​ {{ device.model }} </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>

                            <!-- Name + Comments -->
                            <div class="row">
                                <mat-form-field appearance="outline">
                                    <mat-label>{{ "DEVICES.Name" | translate }}</mat-label>
                                    <input required matInput name="name" formControlName="name" placeholder="{{ baseDevice?.name }}" />
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>{{ "DEVICES.Comments" | translate }}</mat-label>
                                    <input
                                        matInput
                                        name="comments"
                                        formControlName="comments"
                                        placeholder="{{ 'DEVICES.Comments' | translate }}"
                                    />
                                </mat-form-field>
                            </div>

                            <!-- FTP Folder + Data Frequency -->
                            <div class="row">
                                @if (showsFtpFolder) {
                                    <mat-form-field appearance="outline">
                                        <mat-label>{{ "DEVICES.FolderFTP" | translate }}</mat-label>
                                        <input
                                            matInput
                                            name="ftpFolder"
                                            formControlName="ftpFolder"
                                            placeholder="{{ 'DEVICES.FolderFTP' | translate }}"
                                        />
                                    </mat-form-field>
                                }

                                <mat-form-field appearance="outline">
                                    <mat-label>{{ "DEVICES.DataFrequencyCustom" | translate }}</mat-label>
                                    <input
                                        matInput
                                        type="number"
                                        name="dataFrequency"
                                        formControlName="dataFrequency"
                                        placeholder="{{ 'DEVICES.DataFrequencyCustom' | translate }}"
                                    />
                                    @if (baseDevice) {
                                        <mat-hint>{{ "DEVICES.DataFrequencyDevice" | translate }} {{ baseDevice?.dataFrequency }}</mat-hint>
                                    }
                                </mat-form-field>
                            </div>

                            @if (isLF010Device) {
                                <div formGroupName="settings">
                                    <div formGroupName="connection" class="row row--lf010-settings">
                                        <mat-form-field appearance="outline">
                                            <mat-label>{{ "DEVICES.LF010Host" | translate }}</mat-label>
                                            <input
                                                matInput
                                                name="lf010Host"
                                                formControlName="host"
                                                placeholder="{{ 'DEVICES.LF010HostPlaceholder' | translate }}"
                                            />
                                            <mat-hint>
                                                @if (device?.active) {
                                                    {{ "DEVICES.LF010SettingsDisabledWhenActive" | translate }}
                                                } @else {
                                                    {{ "DEVICES.LF010HostHelp" | translate }}
                                                }
                                            </mat-hint>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline">
                                            <mat-label>{{ "DEVICES.LF010Password" | translate }}</mat-label>
                                            <input
                                                matInput
                                                type="password"
                                                name="lf010Password"
                                                formControlName="password"
                                                placeholder="{{ 'DEVICES.LF010PasswordPlaceholder' | translate }}"
                                            />
                                            <mat-hint>
                                                @if (device?.active) {
                                                    {{ "DEVICES.LF010SettingsDisabledWhenActive" | translate }}
                                                } @else {
                                                    {{ "DEVICES.LF010PasswordHelp" | translate }}
                                                }
                                            </mat-hint>
                                        </mat-form-field>
                                    </div>

                                    <div formGroupName="lf010" class="section">
                                        <h2 class="section__title">
                                            <mat-icon>schedule</mat-icon>
                                            <mat-label>{{ "DEVICES.LF010PeriodMapping" | translate }}</mat-label>
                                        </h2>

                                        @if (canConfigureLF010Periods) {
                                            <div class="period-limit-grid" formArrayName="periodMappings">
                                                @for (periodMapping of lf010PeriodMappingsFormArray.controls; track $index) {
                                                    <div class="period-limit-grid__row" [formGroupName]="$index">
                                                        <mat-form-field appearance="outline">
                                                            <mat-label>{{ "DEVICES.LF010DevicePeriod" | translate }}</mat-label>
                                                            <input
                                                                matInput
                                                                [value]="formatLF010DevicePeriodLabel(lf010DevicePeriods[$index])"
                                                                disabled
                                                                readonly
                                                            />
                                                        </mat-form-field>

                                                        <mat-form-field appearance="outline">
                                                            <mat-label>{{ "DEVICES.ProjectPeriod" | translate }}</mat-label>
                                                            <mat-select formControlName="projectPeriodName">
                                                                <mat-option [value]="null">
                                                                    {{ "DEVICES.LF010ProjectPeriodPlaceholder" | translate }}
                                                                </mat-option>
                                                                @for (period of projectPeriods; track period.name) {
                                                                    <mat-option [value]="period.name">
                                                                        {{ period.name }}
                                                                    </mat-option>
                                                                }
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </div>
                                                }
                                            </div>

                                            <mat-hint>
                                                {{
                                                    (hasLF010EmissionLimits
                                                        ? "DEVICES.LF010ApplyAlarmHelp"
                                                        : "DEVICES.LF010ApplyAlarmPendingHelp"
                                                    ) | translate
                                                }}
                                            </mat-hint>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>

                    <!-- Photo -->
                    <div class="device-info-photo">
                        <h2 class="section__title">
                            <mat-icon>image</mat-icon>
                            <mat-label>{{ "DEVICES.Picture" | translate }}</mat-label>
                        </h2>
                        @if (!imageUrl && !imageLoading && !isReadOnly) {
                            <ngx-file-drop dropZoneLabel="{{ 'DEVICES.DropFiles' | translate }}" (onFileDrop)="imageDropped($event)">
                            </ngx-file-drop>
                        }
                        @if (imageLoading) {
                            <div class="image-loading">
                                <mat-spinner diameter="40"></mat-spinner>
                            </div>
                        }
                        @if (imageUrl) {
                            <div class="picture">
                                <div class="picture__preview">
                                    @if (!uploadedFile && imageCloudinaryImage; as deviceImage) {
                                        <advanced-image [cldImg]="deviceImage"></advanced-image>
                                    } @else {
                                        <img [src]="imageUrl" alt="device picture" />
                                    }
                                </div>
                                @if (!isReadOnly) {
                                    <button mat-icon-button color="warn" (click)="removeImage()" class="picture__remove">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                }
                            </div>
                        }
                    </div>
                </div>

                @if (isSvantekDevice) {
                    <div formGroupName="settings" class="section svantek-file-sync-section">
                        <h2 class="section__title">
                            <mat-icon>cloud_download</mat-icon>
                            <mat-label>{{ "DEVICES.SvantekFileSync" | translate }}</mat-label>
                        </h2>

                        <div formGroupName="runtime" class="svantek-config-card svantek-config-card--file-sync">
                            <p class="svantek-config-card__hint">
                                {{ "DEVICES.SvantekFileSyncHelp" | translate }}
                            </p>
                            <mat-slide-toggle formControlName="fileSyncEnabled">
                                {{ "DEVICES.SvantekFileSyncEnabled" | translate }}
                            </mat-slide-toggle>
                        </div>
                    </div>

                    <div formGroupName="settings" class="section svantek-config-section">
                        <h2 class="section__title">
                            <mat-icon>tune</mat-icon>
                            <mat-label>{{ "DEVICES.CustomConfig" | translate }}</mat-label>
                        </h2>

                        <mat-form-field appearance="outline">
                            <mat-label>{{ "DEVICES.DefaultSvantekConfig" | translate }}</mat-label>
                            <input matInput [value]="defaultSvantekConfig" readonly />
                            <mat-hint>
                                {{ "DEVICES.DefaultSvantekConfigHelp" | translate }}
                            </mat-hint>
                        </mat-form-field>

                        <div class="svantek-config-grid">
                            <div class="svantek-config-card">
                                <h3>{{ "DEVICES.SvantekBaselineSummary" | translate }}</h3>
                                <p class="svantek-config-card__hint">
                                    {{ "DEVICES.SvantekBaselineSummaryHelp" | translate }}
                                </p>

                                <div class="svantek-baseline-list">
                                    @for (item of svantekBaselineSummary; track item.label) {
                                        <div class="svantek-baseline-list__item">
                                            <span>{{ item.label | translate }}</span>
                                            <strong>{{ item.value | translate }}</strong>
                                        </div>
                                    }
                                </div>
                            </div>

                            <div class="svantek-config-card" [formGroup]="svantekConfigBuilderForm">
                                <h3>{{ "DEVICES.SvantekOptionalFeatures" | translate }}</h3>
                                <p class="svantek-config-card__hint">
                                    {{ "DEVICES.SvantekOptionalFeaturesHelp" | translate }}
                                </p>

                                <div class="svantek-builder-field">
                                    <mat-form-field appearance="outline">
                                        <mat-label>{{ "DEVICES.SvantekMicrophoneCompensation" | translate }}</mat-label>
                                        <mat-select formControlName="microphoneCompensation">
                                            @for (option of svantekMicrophoneCompensationOptions; track option.value) {
                                                <mat-option [value]="option.value">{{ option.label | translate }}</mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <div class="svantek-builder-field">
                                    <mat-form-field appearance="outline">
                                        <mat-label>{{ "DEVICES.SvantekFreeFieldCompensation" | translate }}</mat-label>
                                        <mat-select formControlName="freeFieldCompensation">
                                            @for (option of svantekFreeFieldCompensationOptions; track option.value) {
                                                <mat-option [value]="option.value">{{ option.label | translate }}</mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <div class="svantek-builder-field">
                                    <mat-form-field appearance="outline">
                                        <mat-label>{{ "DEVICES.SvantekWaveRecordingMode" | translate }}</mat-label>
                                        <mat-select formControlName="waveRecordingMode">
                                            @for (option of svantekWaveRecordingModeOptions; track option.value) {
                                                <mat-option [value]="option.value">{{ option.label | translate }}</mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                @if (usesSvantekWaveRecording) {
                                    <div class="svantek-wave-stack">
                                        <mat-form-field appearance="outline">
                                            <mat-label>{{ "DEVICES.SvantekWaveFileName" | translate }}</mat-label>
                                            <input matInput maxlength="8" formControlName="waveFileName" />
                                            <mat-hint>{{ "DEVICES.SvantekWaveFileNameHelp" | translate }}</mat-hint>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline">
                                            <mat-label>{{ "DEVICES.SvantekWaveFormat" | translate }}</mat-label>
                                            <mat-select formControlName="format">
                                                @for (option of svantekWaveFormatOptions; track option.value) {
                                                    <mat-option [value]="option.value">{{ option.label | translate }}</mat-option>
                                                }
                                            </mat-select>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline">
                                            <mat-label>{{ "DEVICES.SvantekBitsPerSample" | translate }}</mat-label>
                                            <mat-select formControlName="bitsPerSample">
                                                @for (option of svantekBitsPerSampleOptions; track option.value) {
                                                    <mat-option [value]="option.value">{{ option.label | translate }}</mat-option>
                                                }
                                            </mat-select>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline">
                                            <mat-label>{{ "DEVICES.SvantekRecordingTime" | translate }}</mat-label>
                                            <input matInput type="number" min="1" max="28800" formControlName="recordingTime" />
                                            <mat-hint>{{ "DEVICES.SvantekRecordingTimeHelp" | translate }}</mat-hint>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline">
                                            <mat-label>{{ "DEVICES.SvantekRecordingFilter" | translate }}</mat-label>
                                            <mat-select formControlName="recordingFilter">
                                                @for (option of svantekWaveRecordingFilterOptions; track option.value) {
                                                    <mat-option [value]="option.value">{{ option.label | translate }}</mat-option>
                                                }
                                            </mat-select>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline">
                                            <mat-label>{{ "DEVICES.SvantekSamplingRate" | translate }}</mat-label>
                                            <mat-select formControlName="samplingRate">
                                                @for (option of svantekWaveSamplingRateOptions; track option.value) {
                                                    <mat-option [value]="option.value">{{ option.label | translate }}</mat-option>
                                                }
                                            </mat-select>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline">
                                            <mat-label>{{ "DEVICES.SvantekGain" | translate }}</mat-label>
                                            <input matInput type="number" min="0" max="40" formControlName="gain" />
                                            <mat-hint>{{ "DEVICES.SvantekGainHelp" | translate }}</mat-hint>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline">
                                            <mat-label>{{ "DEVICES.SvantekLengthLimit" | translate }}</mat-label>
                                            <mat-select formControlName="lengthLimitMode">
                                                @for (option of svantekLengthLimitOptions; track option.value) {
                                                    <mat-option [value]="option.value">{{ option.label | translate }}</mat-option>
                                                }
                                            </mat-select>
                                        </mat-form-field>

                                        @if (usesSvantekLengthLimitMinutes) {
                                            <mat-form-field appearance="outline">
                                                <mat-label>{{ "DEVICES.SvantekLengthLimitMinutesValue" | translate }}</mat-label>
                                                <input matInput type="number" min="1" max="480" formControlName="lengthLimitMinutes" />
                                            </mat-form-field>
                                        }

                                        @if (showsSvantekWaveTriggerPeriod) {
                                            <mat-form-field appearance="outline">
                                                <mat-label>{{ "DEVICES.SvantekTriggerPeriod" | translate }}</mat-label>
                                                <mat-select formControlName="triggerPeriod">
                                                    @for (option of svantekTriggerPeriodOptions; track option.value) {
                                                        <mat-option [value]="option.value">{{ option.label | translate }}</mat-option>
                                                    }
                                                </mat-select>
                                            </mat-form-field>
                                        }

                                        @if (showsSvantekWavePreTrigger) {
                                            <mat-form-field appearance="outline">
                                                <mat-label>{{ "DEVICES.SvantekPreTrigger" | translate }}</mat-label>
                                                <input matInput type="number" min="0" max="60" formControlName="preTrigger" />
                                                <mat-hint>{{ "DEVICES.SvantekPreTriggerHelp" | translate }}</mat-hint>
                                            </mat-form-field>
                                        }

                                        @if (showsSvantekWaveTriggerLevel) {
                                            <mat-form-field appearance="outline">
                                                <mat-label>{{ "DEVICES.SvantekTriggerLevel" | translate }}</mat-label>
                                                <input matInput type="number" min="24" max="136" formControlName="triggerLevel" />
                                                <mat-hint>{{ "DEVICES.SvantekTriggerLevelHelp" | translate }}</mat-hint>
                                            </mat-form-field>
                                        }

                                        @if (showsSvantekWaveTriggerGradient) {
                                            <mat-form-field appearance="outline">
                                                <mat-label>{{ "DEVICES.SvantekTriggerGradient" | translate }}</mat-label>
                                                <input matInput type="number" min="1" max="100" formControlName="triggerGradient" />
                                                <mat-hint>{{ "DEVICES.SvantekTriggerGradientHelp" | translate }}</mat-hint>
                                            </mat-form-field>
                                        }
                                    </div>
                                }
                            </div>
                        </div>

                        <div formGroupName="runtime" class="svantek-config-card svantek-config-card--raw">
                            <h3>{{ "DEVICES.SvantekAdvancedRawConfig" | translate }}</h3>
                            <p class="svantek-config-card__hint">
                                @if (device?.active) {
                                    {{ "DEVICES.CustomConfigDisabledWhenActive" | translate }}
                                } @else {
                                    {{ "DEVICES.SvantekAdvancedRawConfigHelp" | translate }}
                                }
                            </p>

                            @if (!isSvantekCustomConfigValid) {
                                <p class="svantek-warning">
                                    {{ "DEVICES.SvantekRawConfigInvalid" | translate }}
                                </p>
                            }

                            @if (showsSvantekCompatibilityWarning) {
                                <p class="svantek-warning">
                                    {{ "DEVICES.SvantekCompatibilityWarning" | translate }}
                                </p>
                            }

                            <mat-form-field appearance="outline">
                                <mat-label>{{ "DEVICES.CustomConfig" | translate }}</mat-label>
                                <textarea
                                    matInput
                                    rows="4"
                                    name="customConfig"
                                    formControlName="customConfig"
                                    placeholder="{{ 'DEVICES.CustomConfigPlaceholder' | translate }}"
                                ></textarea>
                                <mat-hint>{{ "DEVICES.CustomConfigHelp" | translate }}</mat-hint>
                            </mat-form-field>

                            <div class="svantek-diff-preview">
                                <div class="svantek-diff-preview__label">{{ "DEVICES.SvantekRawConfigPreview" | translate }}</div>
                                <div class="svantek-diff-preview__value">
                                    <span>#1,</span>
                                    @for (segment of svantekRawConfigDiffSegments; track $index) {
                                        @if (segment.isChanged) {
                                            <strong>{{ segment.token }}</strong>
                                        } @else {
                                            <span>{{ segment.token }}</span>
                                        }
                                        @if (!$last) {
                                            <span>,</span>
                                        } @else {
                                            <span>;</span>
                                        }
                                    }
                                </div>

                                @if (svantekMissingDefaultTokens.length) {
                                    <div class="svantek-diff-preview__label svantek-diff-preview__label--secondary">
                                        {{ "DEVICES.SvantekRawConfigMissing" | translate }}
                                    </div>
                                    <div class="svantek-diff-preview__missing">
                                        @for (token of svantekMissingDefaultTokens; track token) {
                                            <span class="svantek-diff-preview__missing-token">{{ token }}</span>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                }

                <div class="section">
                    @if (isNTIDevice) {
                        <div class="section">
                            <h2 class="section__title">
                                <mat-icon>settings_ethernet</mat-icon>
                                <mat-label>{{ "DEVICES.XL3Connection" | translate }}</mat-label>
                            </h2>

                            <!-- Connection Type -->
                            <mat-form-field appearance="outline">
                                <mat-label>{{ "DEVICES.XL3ConnectionType" | translate }}</mat-label>
                                <mat-select formControlName="xl3ConnectionType">
                                    <mat-option [value]="xl3ConnectionType.Lan">
                                        {{ "DEVICES.XL3ConnectionLan" | translate }}
                                    </mat-option>
                                    <mat-option [value]="xl3ConnectionType.Connect">
                                        {{ "DEVICES.XL3ConnectionConnect" | translate }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- Host/Key + Password -->
                            <div formGroupName="settings">
                                <div formGroupName="connection" class="row">
                                    @if (!usesConnectKey) {
                                        <mat-form-field appearance="outline">
                                            <mat-label>{{ "DEVICES.XL3Host" | translate }}</mat-label>
                                            <input
                                                matInput
                                                name="xl3Host"
                                                formControlName="host"
                                                placeholder="{{ 'DEVICES.XL3Host' | translate }}"
                                            />
                                        </mat-form-field>
                                    }

                                    @if (usesConnectKey) {
                                        <mat-form-field appearance="outline">
                                            <mat-label>{{ "DEVICES.XL3ConnectKey" | translate }}</mat-label>
                                            <input
                                                matInput
                                                name="xl3ConnectKey"
                                                formControlName="connectKey"
                                                placeholder="{{ 'DEVICES.XL3ConnectKey' | translate }}"
                                            />
                                        </mat-form-field>
                                    }

                                    <mat-form-field appearance="outline">
                                        <mat-label>{{ "DEVICES.XL3Password" | translate }}</mat-label>
                                        <input
                                            matInput
                                            type="password"
                                            name="xl3Password"
                                            formControlName="password"
                                            placeholder="{{ 'DEVICES.XL3Password' | translate }}"
                                        />
                                    </mat-form-field>
                                </div>
                            </div>

                            <mat-form-field appearance="outline">
                                <mat-label>{{ "DEVICES.TotalStorageMb" | translate }}</mat-label>
                                <input matInput type="number" name="storage" formControlName="storage" min="1" />
                                <mat-hint>{{ "DEVICES.TotalStorageMbHelp" | translate }}</mat-hint>
                            </mat-form-field>
                        </div>
                    }

                    @if (isSvantekDevice) {
                        <div formGroupName="settings" class="section">
                            <div formGroupName="scheduling">
                                <div formGroupName="restart" class="section">
                                    <h2 class="section__title">
                                        <mat-icon>restart_alt</mat-icon>
                                        <mat-label>{{ "DEVICES.ScheduledRestart" | translate }}</mat-label>
                                    </h2>

                                    <mat-slide-toggle formControlName="enabled">
                                        {{ "DEVICES.ScheduledRestartEnabled" | translate }}
                                    </mat-slide-toggle>

                                    <p class="location-help">
                                        {{ "DEVICES.ScheduledRestartTimezone" | translate: { timezone: scheduledRestartTimezone } }}
                                    </p>

                                    @if (isScheduledRestartEnabled) {
                                        <div class="row">
                                            <mat-form-field appearance="outline">
                                                <mat-label>{{ "DEVICES.ScheduledRestartFrequency" | translate }}</mat-label>
                                                <mat-select formControlName="frequency">
                                                    <mat-option [value]="scheduledRestartFrequency.Weekly">
                                                        {{ "DEVICES.ScheduledRestartWeekly" | translate }}
                                                    </mat-option>
                                                    <mat-option [value]="scheduledRestartFrequency.Monthly">
                                                        {{ "DEVICES.ScheduledRestartMonthly" | translate }}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>

                                            @if (usesWeeklyScheduledRestart) {
                                                <mat-form-field appearance="outline">
                                                    <mat-label>{{ "DEVICES.ScheduledRestartWeekday" | translate }}</mat-label>
                                                    <mat-select formControlName="weekday">
                                                        @for (weekday of svantekRestartWeekdays; track weekday.value) {
                                                            <mat-option [value]="weekday.value">
                                                                {{ weekday.label | translate }}
                                                            </mat-option>
                                                        }
                                                    </mat-select>
                                                </mat-form-field>
                                            } @else {
                                                <mat-form-field appearance="outline">
                                                    <mat-label>{{ "DEVICES.ScheduledRestartMonthDay" | translate }}</mat-label>
                                                    <input matInput type="number" formControlName="monthDay" min="1" max="31" />
                                                </mat-form-field>
                                            }
                                        </div>

                                        <div class="row">
                                            <mat-form-field appearance="outline">
                                                <mat-label>{{ "DEVICES.ScheduledRestartHour" | translate }}</mat-label>
                                                <input matInput type="number" formControlName="hour" min="0" max="23" />
                                            </mat-form-field>

                                            <mat-form-field appearance="outline">
                                                <mat-label>{{ "DEVICES.ScheduledRestartMinute" | translate }}</mat-label>
                                                <input matInput type="number" formControlName="minute" min="0" max="59" />
                                            </mat-form-field>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    }

                    <div formGroupName="settings" class="section">
                        <div formGroupName="specialAlarms" class="section">
                            <h2 class="section__title">
                                <mat-icon>notifications_active</mat-icon>
                                <mat-label>{{ "DEVICES.SpecialAlarms" | translate }}</mat-label>
                            </h2>

                            <p class="location-help">
                                {{ "DEVICES.SpecialAlarmsHelp" | translate }}
                            </p>

                            <div class="row">
                                <mat-slide-toggle formControlName="connectionEnabled">
                                    {{ "DEVICES.SpecialAlarmConnection" | translate }}
                                </mat-slide-toggle>

                                <mat-slide-toggle formControlName="powerSupplyEnabled">
                                    {{ "DEVICES.SpecialAlarmPowerSupply" | translate }}
                                </mat-slide-toggle>
                            </div>

                            <mat-form-field appearance="outline">
                                <mat-label>{{ "DEVICES.SpecialAlarmChannels" | translate }}</mat-label>
                                <mat-select formControlName="notificationChannelIds" multiple>
                                    @for (channel of availableNotificationChannels; track channel.id) {
                                        <mat-option [value]="channel.id">
                                            {{ channel.name }}
                                        </mat-option>
                                    }
                                </mat-select>
                                @if (availableNotificationChannels.length) {
                                    <mat-hint>
                                        {{ "DEVICES.SpecialAlarmChannelsHelp" | translate }}
                                    </mat-hint>
                                } @else {
                                    <mat-hint>
                                        {{ "DEVICES.SpecialAlarmChannelsEmpty" | translate }}
                                    </mat-hint>
                                }
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Location -->
                    <div formGroupName="location" class="section">
                        <h2 class="section__title">
                            <mat-icon>location_on</mat-icon>
                            <mat-label>{{ "DEVICES.Location" | translate }}</mat-label>
                        </h2>

                        <div class="location-search-row">
                            <mat-form-field appearance="outline" class="location-search-row__field">
                                <mat-label>{{ "DEVICES.Address" | translate }}</mat-label>
                                <input
                                    matInput
                                    name="address"
                                    formControlName="address"
                                    placeholder="{{ 'DEVICES.Address' | translate }}"
                                    (blur)="searchAddressOnBlur()"
                                />

                                @if (addressLookupLoading) {
                                    <mat-spinner matSuffix diameter="18"></mat-spinner>
                                }
                            </mat-form-field>
                        </div>

                        @if (!locationDisabled) {
                            <p class="location-help">
                                {{ "DEVICES.AddressHelp" | translate }}
                            </p>
                        }

                        <div class="location-map-card">
                            <div
                                class="location-map"
                                leaflet
                                [leafletOptions]="mapOptions"
                                [leafletLayers]="mapLayers"
                                [leafletZoom]="mapZoom"
                                [leafletCenter]="mapCenter"
                                (leafletMapReady)="onMapReady($event)"
                                (leafletClick)="onMapClick($event)"
                            ></div>

                            @if (reverseLookupLoading) {
                                <div class="location-map-card__loading">
                                    <mat-spinner diameter="20"></mat-spinner>
                                    <span>{{ "DEVICES.SearchingAddress" | translate }}</span>
                                </div>
                            }
                        </div>

                        @if (!locationDisabled) {
                            <p class="location-help">
                                {{ "DEVICES.MapHelp" | translate }}
                            </p>
                        }

                        <div class="row">
                            <mat-form-field appearance="outline">
                                <mat-label>{{ "DEVICES.Latitude" | translate }}</mat-label>
                                <input
                                    matInput
                                    type="number"
                                    name="latitude"
                                    formControlName="latitude"
                                    placeholder="{{ 'DEVICES.Latitude' | translate }}"
                                />
                            </mat-form-field>

                            <mat-form-field appearance="outline">
                                <mat-label>{{ "DEVICES.Longitude" | translate }}</mat-label>
                                <input
                                    matInput
                                    type="number"
                                    name="longitude"
                                    formControlName="longitude"
                                    placeholder="{{ 'DEVICES.Longitude' | translate }}"
                                />
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </mat-dialog-content>
</div>
